/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_Step_3_BodyInputs */

const da_forside_step_3_body = /** @type {(inputs: Forside_Step_3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI retter hver besvarelse to gange uafhængigt og markerer, hvor den er i tvivl. Du ser besvarelsen ved siden af, retter point og godkender karakteren.`)
};

/** @type {(inputs: Forside_Step_3_BodyInputs) => LocalizedString} */
const en_forside_step_3_body = da_forside_step_3_body;

/**

* @param {Forside_Step_3_BodyInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_step_3_body = /** @type {((inputs?: Forside_Step_3_BodyInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Step_3_BodyInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_step_3_body(inputs)
	return /** @type {LocalizedString} */ ("AI retter hver besvarelse to gange uafhængigt og markerer, hvor den er i tvivl. Du ser besvarelsen ved siden af, retter point og godkender karakteren.")
});